import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const navItems = [
  { to: '/dashboard',    icon: 'bi-speedometer2',   label: 'Dashboard' },
  { to: '/funcionarios', icon: 'bi-people',          label: 'Funcionários' },
  { to: '/fit-tests',    icon: 'bi-clipboard-pulse', label: 'Fit Tests' },
  { to: '/agenda',       icon: 'bi-calendar-week',   label: 'Agenda' },
  { to: '/locais',       icon: 'bi-geo-alt',         label: 'Locais' },
];

const fenixItems = [
  { to: '/equipamentos', icon: 'bi-shield',          label: 'Equipamentos' },
  { to: '/empresas',     icon: 'bi-building',        label: 'Empresas' },
  { to: '/usuarios',     icon: 'bi-person-gear',     label: 'Usuários' },
];

const adminItems = [
  { to: '/auditoria', icon: 'bi-shield-lock', label: 'Auditoria' },
];

function SectionLabel({ label, collapsed }) {
  if (collapsed) return <li style={{ padding: '12px 0 4px', borderTop: '1px solid rgba(82,0,255,.08)', marginTop: 4 }} />;
  return (
    <li className="px-2 pt-3 pb-1">
      <span style={{
        fontSize: '.68rem', fontWeight: 700,
        textTransform: 'uppercase', letterSpacing: '.1em', color: '#9ca3af',
      }}>
        {label}
      </span>
    </li>
  );
}

export default function Sidebar() {
  const { isFenix, isAdmin } = useAuth();
  const [collapsed, setCollapsed] = useState(() =>
    localStorage.getItem('sidebar_collapsed') === 'true'
  );

  const toggle = () => {
    setCollapsed(c => {
      localStorage.setItem('sidebar_collapsed', String(!c));
      return !c;
    });
  };

  return (
    <aside className={`sidebar d-flex flex-column ${collapsed ? 'collapsed' : ''}`}>

      {/* Header: brand + toggle */}
      <div className="d-flex align-items-center pb-3 mb-1"
           style={{ borderBottom: '1px solid rgba(82,0,255,.08)', gap: 8, minHeight: 44 }}>
        {!collapsed && (
          <>
            <div style={{
              width: 32, height: 32, borderRadius: 9, flexShrink: 0,
              background: 'var(--gradient-diagonal)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(82,0,255,.3)',
            }}>
              <i className="bi bi-shield-check" style={{ color: '#fff', fontSize: '.95rem' }}></i>
            </div>
            <span style={{
              fontWeight: 700, fontSize: '.95rem', letterSpacing: '-.01em', flex: 1,
              background: 'var(--gradient-diagonal)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            }}>
              FitTest
            </span>
          </>
        )}
        <button
          onClick={toggle}
          title={collapsed ? 'Expandir menu' : 'Recolher menu'}
          style={{
            background: 'transparent', border: 'none', cursor: 'pointer',
            color: '#9ca3af', padding: 4, borderRadius: 8, lineHeight: 1,
            marginLeft: collapsed ? 'auto' : undefined,
            marginRight: collapsed ? 'auto' : undefined,
          }}
        >
          <i className={`bi ${collapsed ? 'bi-layout-sidebar' : 'bi-layout-sidebar-reverse'}`}
             style={{ fontSize: '1.05rem' }}></i>
        </button>
      </div>

      <ul className="nav flex-column gap-1 flex-grow-1 mt-1">
        {navItems.map(({ to, icon, label }) => (
          <li key={to} className="nav-item">
            <NavLink to={to} title={collapsed ? label : undefined}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              <i className={`bi ${icon}`}></i>
              {!collapsed && label}
            </NavLink>
          </li>
        ))}

        {isFenix && (
          <>
            <SectionLabel label={isAdmin ? 'Administração' : 'Fenix'} collapsed={collapsed} />
            {fenixItems.map(({ to, icon, label }) => (
              <li key={to} className="nav-item">
                <NavLink to={to} title={collapsed ? label : undefined}
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                  <i className={`bi ${icon}`}></i>
                  {!collapsed && label}
                </NavLink>
              </li>
            ))}
            {isAdmin && adminItems.map(({ to, icon, label }) => (
              <li key={to} className="nav-item">
                <NavLink to={to} title={collapsed ? label : undefined}
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                  <i className={`bi ${icon}`}></i>
                  {!collapsed && label}
                </NavLink>
              </li>
            ))}
          </>
        )}
      </ul>

      {/* Footer */}
      {!collapsed && (
        <div className="px-2 pt-3 mt-2" style={{ borderTop: '1px solid rgba(82,0,255,.08)' }}>
          <span style={{ fontSize: '.7rem', color: '#c4c9d4', fontWeight: 500 }}>
            Datafit © {new Date().getFullYear()}
          </span>
        </div>
      )}
    </aside>
  );
}
